export default {"src":"/_next/static/media/EUR.efb36ea7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};